import { render, staticRenderFns } from "./_Caixa.vue?vue&type=template&id=15014f1e&scoped=true&"
import script from "./_Caixa.vue?vue&type=script&lang=js&"
export * from "./_Caixa.vue?vue&type=script&lang=js&"
import style0 from "./_Caixa.vue?vue&type=style&index=0&id=15014f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15014f1e",
  null
  
)

export default component.exports